// Scanner state can be shared without loading camera and decoding libraries.
export const SCAN_SCANNING = 'scan-scanning';
export const SCAN_LOADING = 'scan-loading';
export const SCAN_OK = 'scan-ok';
export const SCAN_ERROR = 'scan-error';
